export const InviteMapper = {
  INVITE_SENT: 'INVITE_SENT',
  INVITE_EXPIRED: 'INVITE_EXPIRED',
  INVITE_REJECTED: 'INVITE_REJECTED',
};

export const StatusFilterMapper = {
  ALL: 'all',
  PENDING: 'pending',
  INVITE: 'invite',
  ACTIVE: 'active',
  DECLINED: 'declined',
  ASSIGNED: 'assigned',
  UNASSIGNED: 'unassigned',
  REMOVED: 'removed',
};

export const PermissionFilterMapper = {
  ALL: 'all',
  ADMIN: 'admin',
  SEARCH: 'search',
};

export const TeamsFilterMapper = {
  ALL: 'all',
  UNASSIGNED: 'unassigned',
};

export const CellTypes = {
  CHECK_BOX_CELL: 'CheckBoxCell',
  USER_CELL: 'UserCell',
  ACTION_CELL: 'ActionCell',
  DATE_CELL: 'DateCell',
  CELL: 'Cell',
  LIST_CELL: 'ListCell',
  USERS_CELL: 'UsersCell',
  TEAM_CELL: 'TeamCell',
};

export const ColumnHeaders = {
  USERS: 'Users',
  ADMIN: 'Admin',
  SEARCH: 'Pipl Subscription',
  TEAMS: 'Teams',
  LAST_LOGIN: 'Last login',
  ACTIONS: 'Actions',
};

export const UploadUserListStages = {
  WELCOME: 'welcome',
  UPLOAD_CSV: 'uploadCSV',
  VALIDATE_CSV: 'validateCSV',
  PROGRESS_BAR: 'progressBar',
  SUCCESS: 'success',
};
